import React, { useState } from "react";

function ContactForm() {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await fetch("https://getform.io/f/4f67efdf-5705-406d-82e9-0052db93b689", {
        method: "POST",
        body: new FormData(event.target),
      });

      if (response.ok) {
        setIsSubmitted(true);
      }
    } catch (error) {
      console.error("Form submission error:", error);
    }
  };

  const handleResetForm = () => {
    setIsSubmitted(false);
  };

  return (
    <div className="p-4 shadow-md rounded-lg card project-card">
      <h2 className="text-2xl font-semibold mb-4">Contact Me</h2>
      {isSubmitted ? (
        <div>
          <p>Thank you for your submission!</p>
          <button
            onClick={handleResetForm}
            className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 mt-4"
          >
            Submit Another Form
          </button>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="w-full">
              <input
            type="text"
            name="name"
            placeholder="Your Name"
            className="w-full px-4 py-2 rounded-lg border focus:outline-none focus:ring focus:border-blue-500 mb-4 text-black"
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Your Email"
            className="w-full px-4 py-2 rounded-lg border focus:outline-none focus:ring focus:border-blue-500 mb-4 text-black"
            required
          />

          <textarea
            name="message"
            placeholder="Your Message"
            rows="4"
            className="w-full px-4 py-2 rounded-lg border focus:outline-none focus:ring focus:border-blue-500 mb-4 text-black"
            required
          />

          
          <button
            type="submit"
            className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
          >
            Submit
          </button>
        </form>
      )}
    </div>
  );
}

export default ContactForm;
